// extracted by mini-css-extract-plugin
export default {"workflowDefinitionCreateOrEditDialog":"workflowDefinitionCreateOrEditDialog-eNcFa","structuredDataForm":"structuredDataForm-8ceUe"};